import * as React from 'react';
import { observer } from 'mobx-react';
import { WhiteSpaceProperty } from 'csstype';

let styles = require('./CalendarSurfaceItem.scss');

// the buffer to add to the text box height for decenders space
const heightBuffer = 1;

export interface CalendarSurfaceItemClippingProps {
    lines: number;
    lineHeight: number;
}

/**
 * Template for calendar items content clipping
 */

@observer
export default class CalendarSurfaceItemClipping extends React.Component<
    CalendarSurfaceItemClippingProps,
    {}
> {
    render() {
        let { children, lines, lineHeight } = this.props;
        let wrap = lines > 0 && lines < 2 ? 'nowrap' : 'normal';
        let height =
            Math.floor(lines) > 0 && lineHeight
                ? Math.floor(lines) * lineHeight + heightBuffer
                : 'none';
        let style: React.CSSProperties = {
            minHeight: lines < 0 ? '0px' : height,
            height: lines < 0 ? '0px' : height,
            maxHeight: height,
            whiteSpace: wrap as WhiteSpaceProperty,
        };

        return (
            <span className={styles.clippingContainer} style={style}>
                {children}
            </span>
        );
    }
}
